const format = new Intl.NumberFormat('fr-CH')
export const nF = a => format.format(a)
